<template>
  <div class="select-wrapper">
    <h2>{{ $props.question }}</h2>
    <div class="selections">
      <div class="selection" v-for="(el, i) in $props.selections" :key="i">
        <div
          class="select-image-wrapper shadow grow"
          :class="{ 'selected-image': el.value === selectedValue }"
        >
          <img
            class="select-image"
            :src="el.image"
            :alt="el.name"
            @click="onSelect(el)"
          />
        </div>
        <h3 class="selection-name">{{ el.name }}</h3>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectInput",
  props: {
    question: {
      type: String,
      required: true
    },
    selections: {
      type: Array,
      required: true
    },
    selectedValue: {
      required: true
    },
    clickedCallback: {
      type: Function,
      required: true
    }
  },
  methods: {
    onSelect(selection) {
      this.$props.clickedCallback(selection.value);
    }
  }
};
</script>

<style scoped lang="scss">
@import "../common/_variables.scss";

.select-wrapper {
}
.selections {
  display: flex;
  justify-content: space-between;
  max-width: 920px;
  margin: auto;
  padding-top: 20px;
}
.selection {
  align-items: center;
  flex: 1 1 0px;
  padding: 20px;
}
.select-image-wrapper {
  border-radius: 10px;
  border: 4px solid transparent;
}
.select-image {
  cursor: pointer;
  max-width: 450px;
  width: 100%;
  height: auto;
}
.selected-image {
  border: 4px solid $color-primary;
}

.selection-name {
  margin-top: 20px;
}

@media only screen and (max-width: 768px) {
  .selections {
    flex-direction: column;
  }
  .selection-name {
    margin-bottom: 6px;
  }
}
</style>
